// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__kJB3J","topBottomGutter":"Layout_topBottomGutter__3d4h5"};